import { Routes } from '@angular/router';
import { FORBIDDEN, INTERNAL_SERVER_ERROR, NOT_FOUND, UNAUTHORIZED } from 'http-status-codes';
import { httpErrorPages } from './enums/http-error-pages';
import { GlobalErrorHandlingComponent } from './global-error-handling.component';
var ɵ0 = { statusCode: UNAUTHORIZED }, ɵ1 = { statusCode: FORBIDDEN }, ɵ2 = { statusCode: NOT_FOUND }, ɵ3 = { statusCode: INTERNAL_SERVER_ERROR };
var GlobalErrorHandlingRoutes = [
    { path: httpErrorPages.unauthorized.path, component: GlobalErrorHandlingComponent, data: ɵ0 },
    { path: httpErrorPages.forbidden.path, component: GlobalErrorHandlingComponent, data: ɵ1 },
    { path: httpErrorPages.notFound.path, component: GlobalErrorHandlingComponent, data: ɵ2 },
    { path: httpErrorPages.internalServerError.path, component: GlobalErrorHandlingComponent, data: ɵ3 },
    { path: httpErrorPages.otherError.path, component: GlobalErrorHandlingComponent },
    { path: '**', redirectTo: httpErrorPages.notFound.path }
];
var GlobalErrorHandlingRoutingModule = /** @class */ (function () {
    function GlobalErrorHandlingRoutingModule() {
    }
    return GlobalErrorHandlingRoutingModule;
}());
export { GlobalErrorHandlingRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3 };
